import { atom } from 'recoil';

import { ModalVo } from '@/types/modal';

export const modalState = atom<ModalVo[]>({
  key: 'modalState',
  default: [],
});
